const initState = {
  vendor: {},
  auth: false,
  categories: [],
  menuItems: [],
  superCategories: [],
  subCategories: [],
  city: '',
  sub_category: [],
  products: [],
  transactions:[]
}

const vendorReducer = (state = initState, action) => {
  switch (action.type) {
    case 'VENDOR_LOGIN':
      return { ...state, vendor: action.payload.data, auth: true };
    case 'VENDOR_LOGIN_ERROR':
      return state;
    case 'GET_CATEGORY':
      return { ...state, categories: action.payload.categories[0].categories, city: action.payload.categories[0].city }
    case 'GET_CATEGORY_ERROR':
      return state;
    case 'CREATE_SUBCATEGORY':
      return state;
    case 'CREATE_SUBCATEGORY_ERROR':
      return state;
    case "GET_CITY_CATEGORY":
      return { ...state, superCategories: action.payload.data };
    case "GET_SUPER_CATEGORY_DETAILS":
      return { ...state, superCategoryDetails: action.payload.data };
    case "GET_ALL_CATEGORY":
      return { ...state, categories: action.payload.data };
    case "GET_VENDOR_DETAIL":
      return { ...state, vendorDetail: action.payload.data };
      case "UPDATE_VENDOR_DETAIL":
        return { ...state, vendorDetail: {...state.vendorDetail,commissionType:action.data.commissionType,commissionValue:action.data.commissionValue} };
    case "CREATE_CATEGORY":
      return state;
    case "CREATE_CATEGORY_ERROR":
      return state;
    case "UPDATE_CATEGORY":
      return state;
    case "UPDATE_CATEGORY_ERROR":
      return state;
    case "GET_CATEGORY_DETAILS":
      return { ...state, categoryDetails: action.payload.data };
    case "GET_MENUS":
      return { ...state, menuItems: action.payload.data };
    case "GET_MENUS_DETAILS":
      return { ...state, menusDetails: action.payload.data };
    case "CREATE_MENUS":
      return state;
    case "GET_ALL_SUBCATEGORY":
      return { ...state, subCategories: action.payload.data };
    case "CREATE_SUB_CATEGORY":
      return state;
    case "CREATE_SUB_CATEGORY_ERROR":
      return state;
    case "UPDATE_SUB_CATEGORY":
      return state;
    case "UPDATE_SUB_CATEGORY_ERROR":
      return state;
    case "GET_SUB_CATEGORY_DETAILS":
      return { ...state, subCategoryDetails: action.payload.data };
    case "ADD_SUBCATEGORY":
      return state;
    case "ADD_SUBCATEGORY_ERROR":
      return state;
    case "GET_CITY_CATEGORY_ERROR":
      return state;
    case "GET_ALL_CATEGORY_ERROR":
      return state;
    case "GET_ALL_SUBCATEGORY_ERROR":
      return state;
    case 'SUB_CATEGORY':
      return ({ ...state, sub_category: action.payload })
    case 'ADD_PRODUCT':
      return state
    case 'ADD_PRODUCT_ERROR':
      return state
    case "UPDATE_PRODUCT":
      return state;
    case "UPDATE_PRODUCT_ERROR":
      return state;
    case "GET_PRODUCT_DETAILS":
      return { ...state, productDetails: action.payload.data };
    case "ALL_PRODUCTS":
      return { ...state, products: action.payload };
    case "COMPLETE_PRODUCTS":
      if (action.payload && action.payload.length > 0) {
        const data = action.payload.map((product) => {
          delete product.id
          delete product.isGm
          delete product.isMl
          delete product.vendorId
          delete product.status
          delete product._deleted
          delete product.price_cents
          delete product.active
          delete product.createdAt
          delete product.isOffer
          delete product.offerPrice
          delete product.updatedAt
          if (product.variant) {
            delete product.variant
          }
          return product
        })
        return { ...state, complete_products: data };
      } else {
        return { ...state, complete_products: action.payload };
      }
    case "API_PROGRESS":
      return { ...state, api_loading: action.payload };
    case 'PRODUCT_COUNT':
      return { ...state, products_count: action.payload }

      case 'VENDOR_TRANSACTION_LIST':
        return { ...state, transactions: action.payload };
    default:
      return state;
  }

};

export default vendorReducer;